import {Lead, Loader, Slot, Text, Trail, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {ChangeCard} from '../ChangeCard/ChangeCard'
import * as classes from './classes'
import {useCard} from './hooks'
import type {Props} from './types'

export function Card(props: Props): React.ReactElement {
  const {errorText, isPending, unauthorized, title, iconSrc, card, getBody, changeHandler} = useCard(props)

  return (
    <Slot size="l">
      <Lead
        // @ts-expect-error 😔 кривая типизация GWC, пропс наследуется вот Box
        justifyContent="initial"
        size="m"
      >
        {isPending ? <Loader /> : <img alt={title} height="25px" loading="lazy" src={iconSrc} width="36px" />}
      </Lead>
      {isPending ? null : (
        <>
          <Text>
            <Typography group="tight" thickness="regular" variant="body2">
              {title}
            </Typography>
            {errorText && (
              <Typography color="error" data-error="true" group="tight" thickness="regular" variant="caption1">
                {errorText}
              </Typography>
            )}
          </Text>
          <Trail className={classes.trail}>
            <ChangeCard
              card={card}
              getBody={getBody}
              onChange={changeHandler}
              showRadio={props.showRadio}
              unauthorized={unauthorized}
            />
          </Trail>
        </>
      )}
    </Slot>
  )
}
